export default "__VITE_ASSET__DRIF4$6U__"